function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronUpIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { AnchoredPopout } from '@domain-group/fe-co-popout';
import * as styles from './allhomes-dropdown.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class Dropdown extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "callOnClose", () => {
      if (!this.state.isOpen) {
        this.props.onClose();
      }
    });
    _defineProperty(this, "toggle", () => {
      this.setState(prevState => ({
        isOpen: !prevState.isOpen
      }), () => {
        this.callOnClose();
      });
    });
    _defineProperty(this, "ensureClosed", function () {
      var fireOnCloseEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        }, () => {
          if (fireOnCloseEvent) {
            _this.callOnClose();
          }
        });
      }
    });
    _defineProperty(this, "renderAnchor", _ref => {
      var onClick = _ref.onClick;
      return ___EmotionJSX("button", {
        className: this.props.anchorClass,
        css: styles.anchor,
        onClick: onClick,
        type: "button"
      }, this.props.title, this.props.hasIcon && ___EmotionJSX(React.Fragment, null, this.state.isOpen ? ___EmotionJSX(ChevronUpIcon, {
        css: styles.icon,
        className: this.props.anchorClass
      }) : ___EmotionJSX(ChevronDownIcon, {
        css: styles.icon,
        className: this.props.anchorClass
      })));
    });
    this.state = {
      isOpen: false
    };
  }
  render() {
    return ___EmotionJSX(AnchoredPopout, {
      align: this.props.align,
      className: this.props.className,
      css: styles.dropdown,
      isOpen: this.state.isOpen,
      anchor: this.renderAnchor,
      onClick: this.toggle,
      onClickOutside: this.ensureClosed
    }, ___EmotionJSX("div", {
      className: "allhomes-dropdown__wrapper"
    }, this.props.children));
  }
}
Dropdown.propTypes = {
  className: PropTypes.string,
  anchorClass: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  align: PropTypes.string,
  hasIcon: PropTypes.bool
};
Dropdown.defaultProps = {
  className: undefined,
  anchorClass: null,
  onClose: () => {},
  align: 'left',
  hasIcon: true
};
export default Dropdown;